// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ugxe","controls":"styles_controls__bkFni","charLimit":"styles_charLimit__3FXbB","input":"styles_input__1Tgal","send":"styles_send__2Isnx"};